import types from './actionTypes'

const initialState = {
  selectPrinter: ''
}

export default function settings(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_SELECT_PRINTER:
      return {
        ...state,
        selectPrinter: action.data
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/PrinterSetup/store/reducers.js